export default [
  // City College
  {
    id: 'sc1',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    name: 'Year 10 Mathematics',
    subject: 'MATH-Y10-A',
    studentCount: 24,
    teacherCount: 2,
    hasBeenReviewed: false,
  },
  {
    id: 'sc2',
    purchaserId: '10003',
    action: 'CREATE_NEW_RECORD',
    name: 'Year 11 English Literature',
    subject: 'ENG-Y11-B',
    studentCount: 18,
    teacherCount: 1,
    hasBeenReviewed: true,
  },
  {
    id: 'sc3',
    purchaserId: '10003',
    action: 'DO_NOT_SYNC',
    name: 'Year 9 Science',
    subject: 'SCI-Y9-C',
    academicYear: 2026,
    yearGroup: 'A9',
    studentCount: 22,
    teacherCount: 3,
    hasBeenReviewed: false,
  },
  // Hogwarts (for error scenario testing)
  {
    id: 'sc4',
    purchaserId: '10011',
    action: 'CREATE_NEW_RECORD',
    name: 'Defense Against Dark Arts',
    subject: 'DADA-Y7',
    studentCount: 15,
    teacherCount: 1,
    hasBeenReviewed: false,
  },
];
